import { Text, View } from '@react-pdf/renderer';
import React, { FC } from 'react';
import { IntlFormatters } from '@formatjs/intl/src/types';

import { filterDeletedValues } from 'lib/utils';
import { styles } from 'components/ProfileActions/ResumePdf/styles';
import { rangeText } from 'components/Range/utils';
import messages from '../messages';

type ResumePdfEducationProps = {
  formatMessage: IntlFormatters['formatMessage'];
  profile: AH$Profile;
};

export const ResumePdfEducation: FC<ResumePdfEducationProps> = ({ formatMessage, profile }) => {
  const schools = filterDeletedValues(profile.schools);

  return schools.length ? (
    <>
      <Text style={[styles.subheading, styles.bold, styles.spaceBottomBig]}>
        {formatMessage(messages.schools)}
      </Text>
      {schools.map(({ endMonth, startMonth, startYear, endYear, name, degree }) => {
        const getRangeText = rangeText({
          endYear,
          endMonth,
          startMonth,
          startYear,
          formatMessage,
          format: 'onlyYears',
        });

        return (
          <View style={[styles.section, styles.spaceBottom]}>
            <Text style={[styles.bold, styles.text, styles.spaceBottom]}>{name}</Text>
            {getRangeText ? (
              <Text style={[styles.text, styles.spaceBottom]}>{getRangeText}</Text>
            ) : null}
            {degree ? <Text style={[styles.text, styles.spaceBottom]}>{degree}</Text> : null}
          </View>
        );
      })}
    </>
  ) : null;
};
